import { configureStore } from '@reduxjs/toolkit';
import sliceData from './sliceData/sliceData'
  
 export const store = configureStore({
  reducer: {
    sliceData: sliceData
  }
  });